import * as React from 'react';
import { Card, Box, Stack, Typography } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { AddTask } from '../tasks/AddTask';
import {
    startOfToday,
    endOfToday,
    endOfTomorrow,
    endOfWeek,
    getDay,
    startOfTomorrow,
} from 'date-fns';
import { TasksListFilter } from './TasksListFilter';
import { TasksListEmpty } from './TasksListEmpty';

const today = new Date();
const todayDayOfWeek = getDay(today);
const isBeforeFriday = todayDayOfWeek < 5; // Friday is represented by 5
const todayDateISO = startOfToday().toISOString().substring(0, 10);
const tomorrowDateISO = startOfTomorrow().toISOString().substring(0, 10);
const endOfWeekDateISO = endOfWeek(today, { weekStartsOn: 0 }).toISOString().substring(0, 10);

const modulo = { 'modulo': 'SCM' };

const taskFilters = {
    overdue: { ...modulo, 'due_date@lt': todayDateISO },
    today: {
        ...modulo, 'due_date': todayDateISO,
    },
    tomorrow: {
        ...modulo, 'due_date': tomorrowDateISO,
    },
    thisWeek: {
        ...modulo, 'due_date@gt': tomorrowDateISO,
        'due_date@lte': endOfWeekDateISO,
    },
    later: { ...modulo, 'due_date@gt': endOfWeekDateISO },
};

export const TasksList = () => {
    return (
        <Stack>
            <Box display="flex" alignItems="center" mb={1}>
                <Box mr={1} display="flex">
                    <AssignmentTurnedInIcon
                        color="disabled"
                        fontSize="medium"
                    />
                </Box>
                <Typography variant="h5" color="textSecondary">
                    Tarefas
                </Typography>
                <AddTask reference='suppliercontacts' display="icon" selectContact />
            </Box>
            <Card sx={{ p: 2 }}>
                <Stack>
                    <TasksListEmpty />
                    <TasksListFilter
                        title="Atrasadas"
                        filter={taskFilters.overdue}
                    />
                    <TasksListFilter title="Para hoje" filter={taskFilters.today} />
                    <TasksListFilter
                        title="Amanhã"
                        filter={taskFilters.tomorrow}
                    />
                    {isBeforeFriday && (
                        <TasksListFilter
                            title="Essa semana"
                            filter={taskFilters.thisWeek}
                        />
                    )}
                    <TasksListFilter title="Depois" filter={taskFilters.later} />
                </Stack>
            </Card>
        </Stack>
    );
};
